import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DashboardComponent } from './containers/dashboard/dashboard.component';
import { MqttWidgetComponent } from './components/mqtt-widget/mqtt-widget.component';
import { TranslateModule } from '@ngx-translate/core';
// import the GridModule for the Grid component
import { GridModule } from '@syncfusion/ej2-angular-grids';


@NgModule({
  declarations: [
    DashboardComponent,
    MqttWidgetComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    GridModule
  ]
})
export class DashboardModule { } 
